import { DateTime } from 'luxon';
import { emptyCart } from './cart/cart.js';
import { toLiveItemsV2 } from './live.v2.js';
import { slotToDateTime } from './slotKey.js';
import { emptySiteUserDoc } from './user.js';
import { joinWithRepeatedFormat } from './utils/utils.js';
var LiveState;
(function (LiveState) {
    LiveState["cart"] = "cart";
    LiveState["available"] = "available";
    LiveState["unavailable"] = "unavailable";
    LiveState["timeLocked"] = "timeLocked";
    LiveState["clubLocked"] = "clubLocked";
    // Computed only — never a value an admin picks in the availability editor.
    // Set when a record's `restrictedTo` names groups the user is not in.
    // See docs/plans/groups.md.
    LiveState["groupLocked"] = "groupLocked";
    LiveState["booked"] = "booked";
    LiveState["reserved"] = "reserved";
    LiveState["event"] = "event";
    LiveState["quotaLocked"] = "quotaLocked";
})(LiveState || (LiveState = {}));
const toLiveState = (state) => {
    switch (state) {
        case 'booked':
            return LiveState.booked;
        case 'reserved':
            return LiveState.reserved;
        case 'cart':
            return LiveState.cart;
        case 'available':
            return LiveState.available;
        case 'unavailable':
            return LiveState.unavailable;
        case 'timeLocked':
            return LiveState.timeLocked;
        case 'clubLocked':
            return LiveState.clubLocked;
        case 'groupLocked':
            return LiveState.groupLocked;
        case 'quotaLocked':
            return LiveState.quotaLocked;
    }
    return LiveState.unavailable;
};
/**
 * The real wall-clock bounds of a slot.
 *
 * Both offsets are relative to the BASE slot boundary — endOffset is not
 * chained onto the offset start. startOffset shifts the start forward,
 * endOffset shifts the end backward. Getting this wrong double-counts
 * startOffset. See live.v2.ts (`liveItemTimeRange`), which is the same logic
 * but trapped inside the toLiveItemsV2 closure; de-duplicating that private
 * copy is a follow-up.
 */
const liveItemTimeRange = (item, timezone) => {
    const base = slotToDateTime(item.slotKey, timezone);
    const startOffset = item.startOffset || 0;
    const slotSpan = item.slotSpan || 2;
    const endOffset = item.endOffset || 0;
    return {
        start: base.plus({ minutes: startOffset }),
        end: base.plus({ minutes: slotSpan * 30 - endOffset })
    };
};
const combinedLiveFreeTexts = (live) => {
    const allRefs = Object.values(live.ticketContainers).map((container) => container.ticket.freeText ?? '');
    allRefs.push(live.reference);
    return joinWithRepeatedFormat(allRefs.filter((r) => r !== ''));
};
const notForSaleTicketsMonthly = (month, siteData, calDoc, now) => {
    const daysInMonth = month.daysInMonth ?? 30;
    const allTickets = [];
    for (let i = 1; i < daysInMonth + 1; i++) {
        const dt = month.set({ day: i });
        const itemsForDay = toLiveItemsV2(dt, siteData, emptyCart(), calDoc, {}, false, emptySiteUserDoc(), now);
        const ticketsForDay = itemsForDay
            .map((item) => {
            const containers = Object.values(item.ticketContainers);
            return containers
                .filter((container) => container.state === LiveState.booked ||
                container.state === LiveState.unavailable)
                .map((container) => container.ticket);
        })
            .flat();
        allTickets.push(...ticketsForDay);
    }
    return allTickets;
};
const liveSlotsForRange = (days, siteData, calMap) => {
    const now = DateTime.now().minus({ days: days / 2 });
    const slots = [];
    for (let i = 0; i < days; i++) {
        const dt = now.plus({ days: i });
        const cal = calMap[dt.toFormat('yyyy-MM')];
        if (cal) {
            const daySlots = toLiveItemsV2(dt, siteData, emptyCart(), cal, {}, true, emptySiteUserDoc(), now);
            const booked = daySlots.filter((slot) => {
                return slot.state === LiveState.booked;
            });
            slots.push(...booked);
        }
    }
    return slots;
};
export { combinedLiveFreeTexts, liveItemTimeRange, liveSlotsForRange, LiveState, notForSaleTicketsMonthly, toLiveState };
//# sourceMappingURL=live.js.map